import { render } from "./ServiceCredentialsModal.vue?vue&type=template&id=5d9d36bd&scoped=true&ts=true"
import script from "./ServiceCredentialsModal.vue?vue&type=script&lang=ts"
export * from "./ServiceCredentialsModal.vue?vue&type=script&lang=ts"

import "./ServiceCredentialsModal.vue?vue&type=style&index=0&id=5d9d36bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9d36bd"]])

export default __exports__